import $ from 'jquery';
import pageScripts from './pages/index';
import { Foundation } from 'foundation-sites';
import { Reveal } from 'foundation-sites/js/foundation.reveal';

$(document).foundation();

$(document).ready(function () {
	//Require all components here.
	require('./components/foundation');
	require( './components/shades.js' );
});

// drag & drop
new Sortable(list, {
	handle: '.drag-handle', // handle's class
	animation: 250
});

// input (+) & (-)
$(document).ready(function () {
	var max_fields = 6;
	var wrapper = $(".input_fields_group");
	var add_button = $(".add_field_button");

	var x = 1;
	$(add_button).click(function (e) {
		e.preventDefault();
		if (x < max_fields) {
			x++;
			$(wrapper).append('<li><input class="jscolor" value="7031fe" name="c[]" /><button class="remove_field tipx trans">&#215;</button><button type="button" class="drag-handle tipx drag trans">&#8596;</button></li>');
			var color = new jscolor($(wrapper).find('input.jscolor:last')[0]);
		}
	});

	$(wrapper).on("click", ".remove_field", function (e) {
		e.preventDefault();
		$(this).parent('li').remove(); x--;
	});
});

// Download PNG
$(document).ready(function () {
	$('#save-png').click(function () {
		jQuery('html').scrollTop(0); // scrolling top for screenshot
		var elem = $('#target').get(0);
		html2canvas(document.querySelector("#target")).then(function (canvas) {
			var dataURL = canvas.toDataURL("image/png", 1.0);
			var a = document.createElement('a');
			a.href = dataURL;
			a.download = 'color-scheme-by-seekcolors.png';
			document.body.appendChild(a);
			a.click();
		})
	})
}
);


// Copy

var clipboard = new ClipboardJS('.hex-color');
clipboard.on('success', function(e) {
	e.trigger.classList.add("copied");
	setTimeout(function(){
		e.trigger.blur();
	}, 250);
	setTimeout(function(){
		e.trigger.classList.remove("copied");
	}, 1500);
	e.clearSelection();
});